import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import HttpClient from '../../Api/HttpClient';
import handle401 from '../handle-401';
import config from '../../config';

const accountsListQuery = ({ pageSize = 25, page = 1, sort, filters } = {}) =>
  queryOptions({
    gcTime: 1000 * 60 * 5,
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
    queryKey: ['accounts', pageSize, page, sort, filters],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.getAccountsList({ pageSize, page, sort, filters });

      return {
        ...data,
        pageSize: data.page_size,
        results: data.results.map((account) => ({
          id: account.id,
          name: account.name,
          avatarUrl: config.REACT_S3_URL + account.company_image,
          crmId: account.crm_id,
          completed: account.completed,
          onTrack: account.on_track,
          slipping: account.slipping,
          upside: account.upside,
          internalWeight: account.internal_weight,
          externalWeight: account.external_weight,
          sharedWeight: account.shared_weight,
          internalWeightPercentage: account.internal_weight_percentage,
          externalWeightPercentage: account.external_weight_percentage,
          sharedWeightPercentage: account.shared_weight_percentage,
          totalEffort: account.total_effort,
          totalValue: account.total_value,
          projects: account.projects.map((project) => ({
            id: project.id,
            name: project.name,
            owner: {
              id: project.owner.id,
              firstName: project.owner.first_name,
              lastName: project.owner.last_name,
              avatarUrl: config.REACT_S3_URL + project.owner.avatar,
            },
            closed: project.closed,
            likelyEndDate: project.likely_end_date,
            percentage: project.percentage,
            rushedEndDate: project.rushed_end_date,
            startDate: project.start_date,
            status: project.status,
            statusMonthly: project.status_monthly,
            targetEndDate: project.target_end_date,
            value: project.value,
          })),
        })),
      };
    }),
  });

export default accountsListQuery;
